<template>
  <div ref="box">
    <div class="rect-wrap position-absolute top-0 start-0 h-100 d-flex overflow-hidden" style="">
      <!-- <div v-show="visibleClickLine" :style="{left: clickLineLeft + 'px'}" class="position-absolute frame-time__point">
        <div class="frame-time__line"></div>
        <div class="frame-time__text position-absolute text-nowrap">
          <div>帧序号: {{ curClickPoint.index + 1 }}</div>
          <div>FrameTime: {{ curClickPoint.newData.frame_time }}</div>
          <div v-if="curClickPoint.oldData.frame_time">old: {{ curClickPoint.oldData.frame_time }}</div>
        </div>
      </div> -->
      
      <div v-show="rect.visibleRect" class="position-absolute frame-time__rect" :class="{'is-line': rect.isClick}" 
        :style="{left: rect.rectLeft + 'px', width: rect.rectWidth + 'px', top: rect.rectTop + 'px', height: rect.rectHeight + 'px'}" >
        <div class="line-info position-absolute">
          {{ rect.startXValue }}<span v-show="rect.endXValue != rect.startXValue">-{{ rect.endXValue }}</span>
        </div>
        
        <div class="position-absolute start-100 ps-1 text-nowrap" style="transform: translateX(0) translateY(0);color: #8943d1;">
          <!-- <div><span class="frame-time__label">帧序号:</span> {{ startXIndex + 1 }}-{{ endXIndex + 1 }}</div> -->
          <!-- <div><span class="frame-time__label">Avg(FPS):</span> {{ rectInfo.avgFps }}</div>
          <div><span class="frame-time__label">Min(FPS):</span> {{ rectInfo.minFps }}</div>
          <div><span class="frame-time__label">FPS>=18 [%]:</span> {{ rectInfo.fps18 }}</div>
          <div><span class="frame-time__label">FPS>=25 [%]:</span> {{ rectInfo.fps25 }}</div> -->
        </div>
      </div>
    </div>

    <div v-show="visibleMenu" class="menu position-absolute shadow bg-white" :style="{left: menuLeft + 'px', top: menuTop + 'px'}" @click.prevent>
      <button type="button" class="btn-operate d-block py-2 px-3 border-0 w-100" :disabled="!isAllChecked" @click="onEditLabel">
        <i class="el-icon-edit-outline me-2" style="font-size: 16px;"></i>标签
      </button>
      <button type="button" class="btn-operate d-block py-2 px-3 border-0 w-100" :disabled="!isAllChecked" @click="onDelete">
        <i class="el-icon-delete me-2" style="font-size: 16px;"></i>删除
      </button>
    </div>
  </div>
</template>

<script>
import {allChart, sleep} from './common.js'
import axios from 'axios'
import {ElMessageBox} from 'element-plus'

//点击和框选功能
const useRect = {
  data() {
    return {
      isDrawing: false,
      visibleClickLine: false,
      clickLineLeft: null,
      curClickPoint: {newData: {}, oldData: {}},
      rectInfo: {},
      curIndex: null,
      startX: null,
      startXIndex: null,
      startXValue: null,
    }
  },

  methods: {
    getAvgFps(curFpsRange) {
      let sum = 0
      for (let i = 0; i < curFpsRange.length; i++) {
        sum += curFpsRange[i]
      }

      return (sum / curFpsRange.length).toFixed(1)
    },

    getAvgFrameTime(curFrameTimeRange) {
      let sum = 0
      for (let i = 0; i < curFrameTimeRange.length; i++) {
        sum += curFrameTimeRange[i]
      }

      return (sum / curFrameTimeRange.length).toFixed(1)
    },

    getRectInfo() {
      const curRange = this.chartData?.new?.slice(this.rect.startXIndex, this.rect.endXIndex + 1) || [],
        curFpsRange = curRange.map(item => item.fps),
        curFrameTimeRange = curRange.map(item => item.frame_time),
        avgFps = this.getAvgFps(curFpsRange),
        minFps = Math.min(...curFpsRange),
        fps18 = ((curFpsRange.filter(item => item >= 18).length / curFpsRange.length) * 100).toFixed(1) + '%',
        fps25 = ((curFpsRange.filter(item => item >= 25).length / curFpsRange.length) * 100).toFixed(1) + '%',
        avgFrameTime = this.getAvgFrameTime(curFrameTimeRange),
        maxFrameTime = Math.max(...curFrameTimeRange),
        frameTime100 = ((curFrameTimeRange.filter(item => item >= 100).length / curFrameTimeRange.length) * 100).toFixed(1) + '%',
        frameTime40 = ((curFrameTimeRange.filter(item => item >= 40).length / curFrameTimeRange.length) * 100).toFixed(1) + '%'

      this.rectInfo = {avgFps, minFps, fps18, fps25, avgFrameTime, maxFrameTime, frameTime100, frameTime40}
    },

    getXAxisValue(myChart, offsetX, offsetY) {
      //获取 ECharts 实例的坐标系转换器
      const pointInPixel = [offsetX, offsetY]
      const pointInGrid = myChart.convertFromPixel('grid', pointInPixel)

      //获取 x 轴的值
      const xIndex = pointInGrid[0]
      const xAxisData = myChart.getOption()?.xAxis?.[0]?.data
      const xAxisValue = xAxisData[xIndex]
    
      return [xIndex, xAxisValue]
    },

    drawRect2() { //有性能问题，比较卡
      Object.values(allChart).forEach(chart => {
        if (!chart) return
        chart.setOption({
          graphic: {
            elements: [{
              type: 'rect',
              shape: {
                x: this.rect.rectLeft,
                y: 100,
                width: this.rect.rectWidth,
                height: 200,
              },
              style: {
                fill: 'rgba(19, 100, 233, .2)',
                stroke: '#1364e9',
                lineWidth: 2,
              }
            }]
          }
        })
      })
    },

    drawRect(myChart, params) {
      const [xIndex, xAxisValue] = this.getXAxisValue(myChart, params.offsetX, params.offsetY)
          
      if (params.offsetX - this.startX >= 0) {
        this.rect.rectLeft = this.startX
        this.rect.rectWidth = params.offsetX - this.startX

        this.rect.startXIndex = this.startXIndex
        this.rect.endXIndex = xIndex
        this.rect.startXValue = this.startXValue
        this.rect.endXValue = xAxisValue
      } else {
        this.rect.rectLeft = params.offsetX
        this.rect.rectWidth = this.startX - params.offsetX

        this.rect.startXIndex = xIndex
        this.rect.endXIndex = this.startXIndex
        this.rect.startXValue = xAxisValue
        this.rect.endXValue = this.startXValue
      }

      this.rect.visibleRect = true
    },

    onMouseEvent(myChart) {
      let startXIndex = null
      let startXValue = null

      //监听 mousedown 事件
      myChart.getZr().on('mousedown', (params) => {
        if (params.event.button !== 0) return //仅响应左键点击事件
        this.visibleMenu = false
        const pointInPixel = [params.offsetX, params.offsetY] //获取点击的 触发点像素坐标
        
        if (myChart.containPixel('grid', pointInPixel)) { //判断给定的点是否在指定的坐标系或者系列上
          this.rect.isClick = true
          this.isDrawing = true
          this.rectInfo = {}
          this.startX = params.offsetX
          const [xIndex, xAxisValue] = this.getXAxisValue(myChart, params.offsetX, params.offsetY)
          this.rect.startXIndex = this.startXIndex = xIndex
          this.rect.startXValue = this.startXValue = xAxisValue
        }
      })
     
      myChart.getZr().on('mousemove', (params) => {
        if (!this.isDrawing) return
        
        const pointInPixel = [params.offsetX, params.offsetY] //获取点击的 触发点像素坐标
        if (myChart.containPixel('grid', pointInPixel)) { //判断给定的点是否在指定的坐标系或者系列上
          this.rect.isClick = false
          this.drawRect(myChart, params)
          //this.visibleClickLine = false
        } else { //鼠标超出grid区域时停止框选
          this.isDrawing = false
        }
      })
      
      //监听 mouseup 事件
      myChart.getZr().on('mouseup', (params) => {
        if (!this.isDrawing) return
        const pointInPixel = [params.offsetX, params.offsetY] //获取点击的 触发点像素坐标
        if (myChart.containPixel('grid', pointInPixel)) { //判断给定的点是否在指定的坐标系或者系列上
          this.isDrawing = false
          this.drawRect(myChart, params)
          if (this.rect.isClick) {
            this.showScreenShot()(this.startXValue)
          }

          //if (this.rect.startXIndex === this.rect.endXIndex) return
          //处理框选
          //this.getRectInfo()
          //this.isMultiFrame = true
        }
      })
    },

    showClickLine(index, param) {
      this.rect.visibleRect = false
      this.visibleClickLine = true
      this.clickLineLeft = param.offsetX
      this.curClickPoint = {
        index,
        newData: this.chartData.new[index] || {},
        oldData: this.chartData.old[index] || {},
      }
    },
  }
}

export default {
  mixins: [useRect],

  inject: ['rect', 'showDialogLabel', 'initAll', 'injectObj', 'showScreenShot'],

  data() {
    return {
      visibleMenu: false,
      menuLeft: 0,
      menuTop: 0,
    }
  },

  computed: {
    project() {
      return this.$route.query.project
    },

    id_test() {
      return this.$route.query.id_test
    },

    isAllChecked() {
      return this.injectObj.isAllChecked
    },
  },

  props: {
    chartKey: String,
  },

  methods: {
    init(isMounted) {
      if (isMounted) {
        const chart = allChart[this.chartKey]
        this.onMouseEvent(chart)
        this.onChartContext(chart)
      }
    },

    onEditLabel() {
      this.visibleMenu = false
      if (!this.rect.isClick) this.showDialogLabel()
    },

    async onDelete() {
      this.visibleMenu = false
      if (this.rect.isClick) return

      ElMessageBox.confirm('确认删除？', '提示', {type: 'warning'})
        .then(async () => {
          await axios.delete('performance/label/', {
            params: {
              project: this.project,
              id_test: this.id_test,
              start: this.rect.startXValue,
              end: this.rect.endXValue,
            }
          })
          
          this.initAll()
        })
        .catch(() => {
          //
        })
    },

    isClickRect(params) { //是否点击了矩形选框
      const {rectLeft, rectWidth, rectTop, rectHeight} = this.rect
      return params.offsetX >= rectLeft && params.offsetX <= (rectLeft + rectWidth) && params.offsetY >= rectTop && params.offsetY <= rectTop + rectHeight
    },

    onChartContext(chart) { //右键点击图表时
      chart.getZr().on('contextmenu', params => {
        params.event.preventDefault() //阻止默认的上下文菜单
      
        if (!this.rect.isClick && this.isClickRect(params)) {
          this.menuLeft = params.offsetX + 4
          this.menuTop = params.offsetY + 4
          this.visibleMenu = true
        } else {
          this.visibleMenu = false
          this.rect.visibleRect = false
        }
      })
    },
  }
}
</script>

<style scoped>
.frame-time__point {
  top: 61px;
}

.frame-time__line {
  position: relative;
  left: -1.5px;
  width: 3px;
  height: 170px;
  background: #8943d1;
}

.frame-time__text {
  top: 7px;
  left: 5px;
  color: #8943d1;
  font-size: 15px;
}

.rect-wrap {
  width: 1440px;
  padding: 0 50px 0 50px;
  pointer-events: none;
  box-sizing: content-box;
  clip-path: content-box;
}

.frame-time__rect {
  /* top: 100px;
  bottom: 100px; */
  border: 2px solid #1364e9;
  background: rgba(19, 100, 233, .2);
  /* pointer-events: auto; */
}

.frame-time__rect.is-line {
  border: none;
  width: 3px!important;
  background: #1364e9;
  transform: translateX(-1px);
}

.line-info {
  left: 50%;
  transform: translateX(-50%);
  top: -24px;
  color: #1364e9;
}

.frame-time__label {
  display: inline-block;
  width: 100px;
}

.frame-time__label2 {
  display: inline-block;
  width: 140px;
}

.menu {
  z-index: 10;
}

.btn-operate {
  background: none;
}

.btn-operate:not([disabled]):hover {
  color: blue;
  background: rgb(248,249,250);
}
</style>